// helpers, utitlities, plugins, etc. etc.
// for masterbrand landing page
var masterbrand = (function() {
	/**
	* http://robertpenner.com/easing/
	*/
	var easing = { 
		easeInQuad: function (t, b, c, d) {
			return c*(t/=d)*t + b;
		},
		easeOutQuad: function (t, b, c, d) {
			return -c *(t/=d)*(t-2) + b;
		},
		easeInOutQuad: function (t, b, c, d) {
			if ((t/=d/2) < 1) {
				return c/2*t*t + b;
			}
			return -c/2 * ((--t)*(t-2) - 1) + b;
		},
		easeInCubic: function (t, b, c, d) {
			return c*(t/=d)*t*t + b;
		},
		easeOutCubic: function (t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
		easeInOutCubic: function (t, b, c, d) {
			if ((t/=d/2) < 1) {
				return c/2*t*t*t + b;
			}
			return c/2*((t-=2)*t*t + 2) + b;
		},
		easeInQuart: function (t, b, c, d) {
			return c*(t/=d)*t*t*t + b;
		},
		easeOutQuart: function (t, b, c, d) {
			return -c * ((t=t/d-1)*t*t*t - 1) + b;
		},
		easeInOutQuart: function (t, b, c, d) {
			if ((t/=d/2) < 1) {
				return c/2*t*t*t*t + b;
			}
			return -c/2 * ((t-=2)*t*t*t - 2) + b;
		},
		easeInQuint: function (t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
		},
		easeOutQuint: function (t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
		},
		easeInOutQuint: function (t, b, c, d) {
			if ((t/=d/2) < 1) {
				return c/2*t*t*t*t*t + b;
			}
			return c/2*((t-=2)*t*t*t*t + 2) + b;
		},
		easeInSine: function (t, b, c, d) {
			return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
		},
		easeOutSine: function (t, b, c, d) {
			return c * Math.sin(t/d * (Math.PI/2)) + b;
		},
		easeInOutSine: function (t, b, c, d) {
			return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
		},
		easeInExpo: function (t, b, c, d) {
			return (t===0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
		},
		easeOutExpo: function (t, b, c, d) {
			return (t===d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInOutExpo: function (t, b, c, d) {
			if (t===0) {
				return b;
			}
			if (t===d) {
				return b+c;
			}
			if ((t/=d/2) < 1) {
				return c/2 * Math.pow(2, 10 * (t - 1)) + b;
			}
			return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
		},
		easeInCirc: function (t, b, c, d) {
			return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
		},
		easeOutCirc: function (t, b, c, d) {
			return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
		},
		easeInOutCirc: function (t, b, c, d) {
			if ((t/=d/2) < 1) {
				return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
			}
			return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
		},
		easeInElastic: function (t, b, c, d) {
			var s=1.70158;
			var p=0;
			var a=c;
			if (t===0) {
				return b;  
			}
			if ((t/=d)===1) {
				return b+c;  
			}
			if (!p) {
				p=d*0.3;
			}
			if (a < Math.abs(c)) { 
				a=c;
				s=p/4; 
			} else {
				s = p/(2*Math.PI) * Math.asin (c/a);
			}
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (t, b, c, d) {
			var s=1.70158;
			var p=0;
			var a=c;
			if (t===0) {
				return b;  
			}
			if ((t/=d)===1) {
				return b+c;  
			}
			if (!p) {
				p=d*0.3;
			}
			if (a < Math.abs(c)) { 
				a=c; 
				s=p/4; 
			} else {
				s = p/(2*Math.PI) * Math.asin (c/a);
			}
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		},
		easeInOutElastic: function (t, b, c, d) {
			var s=1.70158;
			var p=0;
			var a=c;
			if (t===0) {
				return b;  
			}
			if ((t/=d/2)===2) {
				return b+c;  
			}
			if (!p) {
				p=d*(0.3*1.5);
			}
			if (a < Math.abs(c)) { 
				a=c; 
				s=p/4; 
			}
			else { 
				s = p/(2*Math.PI) * Math.asin (c/a);
			}
			if (t < 1) {
				return -0.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
			}
			return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*0.5 + c + b;
		},
		easeInBack: function (t, b, c, d, s) {
			if (s === undefined) {
				s = 1.70158;
			}
			return c*(t/=d)*t*((s+1)*t - s) + b;
		},
		easeOutBack: function (t, b, c, d, s) {
			if (s === undefined) {
				s = 1.70158;
			}
			return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
		},
		easeInOutBack: function (t, b, c, d, s) {
			if (s === undefined) {
				s = 1.70158; 
			}
			if ((t/=d/2) < 1) {
				return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
			}
			return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
		},
		easeInBounce: function (t, b, c, d) {
			return c - easing.easeOutBounce (d-t, 0, c, d) + b;
		},
		easeOutBounce: function (t, b, c, d) {
			if ((t/=d) < (1/2.75)) {
				return c*(7.5625*t*t) + b;
			} else if (t < (2/2.75)) {
				return c*(7.5625*(t-=(1.5/2.75))*t + 0.75) + b;
			} else if (t < (2.5/2.75)) {
				return c*(7.5625*(t-=(2.25/2.75))*t + 0.9375) + b;
			} else {
				return c*(7.5625*(t-=(2.625/2.75))*t + 0.984375) + b;
			}
		},
		easeInOutBounce: function (t, b, c, d) {
			if (t < d/2) {
				return easing.easeInBounce (t * 2, 0, c, d) * 0.5 + b;
			}
			return easing.easeOutBounce (t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
		}
	};

	/**
	* https://www.sitepoint.com/smooth-scrolling-vanilla-javascript/
	*/
	var jump = function(target, options) {
	    var start = window.pageYOffset;

		options = (typeof options === 'object') ? options : {};

	    var opt = {
	      duration: options.duration || 1200,
	      offset: options.offset || 0,
	      callback: options.callback,
	      easing: options.easing || easing.easeInOutExpo
	    };

	    var distance = 
	    	typeof target === 'string' ? 
	        	opt.offset + document.querySelector( '.' + target ).getBoundingClientRect().top : 
	        	opt.offset + target.getBoundingClientRect().top
	    ;

	    var duration = typeof opt.duration === 'function' ? 
	    	opt.duration(distance) :
			opt.duration
	    ;

	    var timeStart = null,
	        timeElapsed;

		function end() {
			window.scrollTo(0, start + distance);

			if (typeof opt.callback === 'function' && opt.callback()) {
				timeStart = null;	
			}
		}

		function loop(time) {
			timeElapsed = time - timeStart;

			window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

			if (timeElapsed < duration) {
				requestAnimationFrame(loop);
			} else {
				end();
			}
		}

		requestAnimationFrame(function(time) { timeStart = time; loop(time); });
	};

	/**
	* https://davidwalsh.name/function-debounce
	* Returns a function, that, as long as it continues to be invoked, will not be triggered.
	* @param  {Function} func - Callback function
	* @param  {int} wait - The function will be called after it stops being called for N milliseconds
	* @param  {boolean} immediate - If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
	*/
	var debounce = function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	};

	/**
	* https://gomakethings.com/ditching-jquery/#waiting-until-the-dom-is-ready
	* Run event after DOM is ready
	* @param  {Function} fn - Callback function
	*/
	var ready = function ( fn ) {
		// Sanity check
		if ( typeof fn !== 'function' ) {
			return;
		}

		// If document is already loaded, run method
		if ( document.readyState === 'complete'  ) {
		    return fn();
		}

		// Otherwise, wait until document is loaded
		document.addEventListener( 'DOMContentLoaded', fn, false );
	};
	// Example

	/**
	* https://gomakethings.com/ditching-jquery/#manipulate-height
	* Get the height of an element
	* @param  {Node}   elem The element
	* @return {Number}      The height
	*/
	var getHeight = function ( elem ) {
		return Math.max( elem.scrollHeight, elem.offsetHeight, elem.clientHeight );
	};

	/**
	* https://gomakethings.com/ditching-jquery/#is-an-element-in-the-viewport
	* Determine if an element is in the viewport
	* @param  {Node}    elem The element
	* @return {Boolean}      Returns true if element is in the viewport
	*/
	var isInViewport = function ( elem ) {
		var distance = elem.getBoundingClientRect();
		return (
			distance.top >= 0 &&
			distance.left >= 0 &&
			distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			distance.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	/**
	* https://gomakethings.com/ditching-jquery/#get-distances-to-the-top-of-the-document
	* Get an element's distance from the top of the page
	* @param  {Node}   elem The element
	* @return {Number}      Distance from the top of the page
	*/
	var getElemDistance = function ( elem ) {
		var location = 0;
		if ( elem.offsetParent ) {
			do {
				location += elem.offsetTop;
				elem = elem.offsetParent;
			} while ( elem );
		}
		return location >= 0 ? location : 0;
	};

	/**
	* https://gomakethings.com/ditching-jquery/#climb-up-the-dom
	* Get all of an element's parent elements up the DOM tree
	* @param  {Node}   elem     The element
	* @param  {String} selector A class, ID, data attribute or tag to filter against [optional]
	* @return {Array}           The parent elements
	*/
	var getParents = function ( elem, selector ) {
		var parents = [];
		var firstChar;

		if ( selector ) {
			firstChar = selector.charAt(0);
		}

		// Get matches
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( selector ) {
				// If selector is a class
				if ( firstChar === '.' ) {
					if ( elem.classList.contains( selector.substr(1) ) ) {
						parents.push( elem );
					}
				}
				// If selector is an ID
				if ( firstChar === '#' ) {
					if ( elem.id === selector.substr(1) ) {
						parents.push( elem );
					}
				}
				// If selector is a data attribute
				if ( firstChar === '[' ) {
					if ( elem.hasAttribute( selector.substr(1, selector.length - 1) ) ) {
						parents.push( elem );
					}
				}
				// If selector is a tag
				if ( elem.tagName.toLowerCase() === selector ) {
					parents.push( elem );
				}
			} else {
				parents.push( elem );
			}
		}

		// Return parents if any exist
		if ( parents.length === 0 ) {
			return null;
		} else {
			return parents;
		}
	};

	/**
	* https://gomakethings.com/ditching-jquery/#get-sibling-elements
	* Get all siblings of an element
	* edited by: Siloah Audie A. Catalon - added option to get next and prev siblings,
	* @param  {Node}  elem The element
	* @param  {string} order: prev || next, default: all
	* @return {Array}      The siblings
	*/
	var getSiblings = function ( elem, order) {
		var prevSiblings = [];
		var siblings = [];
		var nextSiblings = [];

		if ( order === 'prev' ) {
			while( (elem = elem.previousSibling) != null ) {
				if ( elem.nodeType === 1 ) {
					prevSiblings.push( elem );
				}
			}
			return prevSiblings;
		} else if ( order === 'next' ) {
			while( (elem = elem.nextSibling) != null ) {
				if ( elem.nodeType === 1 ) {
					nextSiblings.push( elem );
				}
			}
			return nextSiblings;
		} else {
			var sibling = elem.parentNode.firstChild;
			for ( ; sibling; sibling = sibling.nextSibling ) {
				if ( sibling.nodeType === 1 && sibling !== elem ) {
					siblings.push( sibling );
				}
			}
			return siblings;
		}
	};

	/**
	* run function sequential
	*/
	var runSequence = function (tasks, callback) {
		var storedFn = callback;

		tasks.reverse().forEach(function(task) {
			var next = storedFn;
			storedFn = function() {
				task(next);
			};
		});
		storedFn();
	};

	/**
	* run callback function if condition is true
	*/
	var when = function( condition, callback ){
		var rafID;

		if(condition()){
			cancelAnimationFrame(rafID);
			return callback();
		} else {
			cancelAnimationFrame(rafID);

			rafID = requestAnimationFrame(function() {
				when(condition, callback);
			});
		}
	};

	var devTools = function() {
		/* cls = console.clear() */
		Object.defineProperty(window, 'cls', {
			get: function () {
				return console.clear();
			}
		});
	};

	/**
	* disable/enable scroll
	* scroll.on : enable scroll
	* scroll.off : disable scroll
	*/
	var scroll = {
		keys : [32, 33, 34, 35, 36, 37, 38, 39, 40],
		preventDefault : function (e) {
			e = e || window.event;
			if (e.preventDefault) {
				e.preventDefault();
				e.returnValue = false;
			}
		},
		keydown : function (e) {
			for (var i = scroll.keys.length; i--;) {
				if (e.keyCode === scroll.keys[i]) {
					scroll.preventDefault(e);
					return;
				}
			}
		},
		wheel : function (e) {
			scroll.preventDefault(e);
		},
		touch : function (e) {
			scroll.preventDefault(e);	
		}
	};

	Object.defineProperty(scroll, 'off', {
		get: function() {
			if (window.addEventListener) {
				window.addEventListener('DOMMouseScroll', this.wheel, false);
				window.addEventListener('touchmove', this.touch, false);
				window.addEventListener('touchstart', this.touch, false);
			}
			window.onmousewheel = document.onmousewheel = this.wheel;
			document.onkeydown = this.keydown;
		}
	});

	Object.defineProperty(scroll, 'on', {
		get: function() {
			if (window.removeEventListener) {
				window.removeEventListener('DOMMouseScroll', this.wheel, false);
				window.removeEventListener('touchmove', this.touch, false);
				window.removeEventListener('touchstart', this.touch, false);
			}
			window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
		}
	});

	return {
		debounce: debounce,
		devTools: devTools,
		easing: easing,
		getElemDistance: getElemDistance,
		getHeight: getHeight,
		getParents: getParents,
		getSiblings: getSiblings,
		isInViewport: isInViewport,
		jump: jump,
		ready: ready,
		runSequence: runSequence,
		scroll: scroll,
		when: when
	};

})();

for (var i in masterbrand) {
	Object.defineProperty(masterbrand, i, {
		writable: false,
		configurable: false,
		enumerable: false
	});
}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || 
        	window[vendors[x]+'CancelRequestAnimationFrame'];
    }
 
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
 
    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
     }
}());